import Vue from "vue";
import Vuex from "vuex";

import accounts from "./modules/accounts.module";
import areas from "./modules/areas.module";
import authentication from "./modules/authentication.module";
import authorizationTokens from "./modules/authorizationTokens.module";
import claims from "./modules/claims.module";
import companies from "./modules/companies.module";
import customers from "./modules/customers.module";
import customerDependants from "./modules/customerDependants.module";
import dayBatches from "./modules/dayBatches.module";
import disciplines from "./modules/disciplines.module";
import files from "./modules/files.module";
import identities from "./modules/identities.module";
import incidents from "./modules/incidents.module";
import patients from "./modules/patients.module";
import providerGroups from "./modules/providerGroups.module";
import providers from "./modules/providers.module";
import reports from "./modules/reports.module";
import sapdmetros from "./modules/sapdmetros.module";
import subscriptions from "./modules/subscriptions.module";
import users from "./modules/users.module";

import representatives from "./modules/representatives.module";
import representativeProducts from "./modules/representativeProducts.module";
import subscribeFormSubmissions from "./modules/subscribeFormSubmissions.module";

import deprecatedaccounts from "./modules/deprecatedaccounts.module";
import deprecatedincidents from "./modules/deprecatedincidents.module";

import medikreditclaimcsvs from "./modules/medikreditclaimcsvs.module";
import medikreditclaims from "./modules/medikreditclaims.module";

import sms from "./modules/sms.module";

import brokers from "./modules/brokers.module";
import brokerfirms from "./modules/brokerfirms.module";
import billings from "./modules/billings.module";
import billingitems from "./modules/billingitems.module";

import customerimportjobs from "./modules/customerimportjobs.module";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        accounts,
        areas,
        authentication,
        authorizationTokens,
        claims,
        companies,
        customers,
        customerDependants,
        dayBatches,
        disciplines,
        files,
        identities,
        incidents,
        patients,
        providerGroups,
        providers,
        reports,
        sapdmetros,
        subscriptions,
        users,

        representatives,
        representativeProducts,
        subscribeFormSubmissions,

        deprecatedaccounts,
        deprecatedincidents,

        medikreditclaimcsvs,
        medikreditclaims,
        sms,

        brokers,
        brokerfirms,
        billings,
        billingitems,

        customerimportjobs
    },
});
